import { Md123, MdAbc, MdDateRange } from 'react-icons/md';

export const defaultDataType = {
  ALL: 'ALL',
  NUM: 'NUM',
  CAT: 'CAT',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN',
  GEO: 'GEO',
  ID: 'ID',
  ID_TEXT: 'ID_TEXT',
  ID_NUM: 'ID_NUM',
};
export const allConditionData = {
  contains: {
    name: 'Contains',
    key: 'contains',
    defaultValue: '',
    valueTypeArray: false,
  },
  notContains: {
    name: 'Not Contains',
    key: 'notContains',
    defaultValue: '',
    valueTypeArray: false,
  },
  equals: {
    name: 'Equals to',
    key: 'equals',
    defaultValue: '',
    valueTypeArray: false,
  },
  notEquals: {
    name: 'Not Equals to',
    key: 'notEquals',
    defaultValue: '',
    valueTypeArray: false,
  },
  startWith: {
    name: 'Start With',
    key: 'startWith',
    defaultValue: '',
    valueTypeArray: false,
  },

  endWith: {
    name: 'End With',
    key: 'endWith',
    defaultValue: '',
    valueTypeArray: false,
  },
  include: {
    name: 'Include',
    key: 'include',
    defaultValue: [],
    valueTypeArray: true,
  },
  notIncludes: {
    name: 'Not Includes',
    key: 'notIncludes',
    defaultValue: [],
    valueTypeArray: true,
  },
  regexp: {
    name: 'Regex Expression',
    key: 'regexp',
    defaultValue: '',
    valueTypeArray: false,
  },
  lessThan: {
    name: 'Less Than',
    key: 'lessThan',
    defaultValue: '',
    valueTypeArray: false,
  },
  lessThanOrEqual: {
    name: 'Less Than Or Equal',
    key: 'lessThanOrEqual',
    defaultValue: '',
    valueTypeArray: false,
  },
  greaterThan: {
    name: 'Greater Than',
    key: 'greaterThan',
    defaultValue: '',
    valueTypeArray: false,
  },
  greaterThanOrEqual: {
    name: 'Greater Than Or Equal',
    key: 'greaterThanOrEqual',
    defaultValue: '',
    valueTypeArray: false,
  },
  inRange: {
    name: 'In Range',
    key: 'inRange',
    defaultValue: '',
    valueTypeArray: false,
  },
  before: {
    name: 'Before',
    key: 'before',
    defaultValue: '',
    valueTypeArray: false,
  },
  onOrBefore: {
    name: 'On Or Before',
    key: 'onOrBefore',
    defaultValue: '',
    valueTypeArray: false,
  },
  after: {
    name: 'After',
    key: 'after',
    defaultValue: '',
    valueTypeArray: false,
  },
  onOrAfter: {
    name: 'On Or After',
    key: 'onOrAfter',
    defaultValue: '',
    valueTypeArray: false,
  },
};
export const textConditionData = {
  contains: allConditionData.contains,
  notContains: allConditionData.notContains,
  equals: allConditionData.equals,
  notEquals: allConditionData.notEquals,
  startWith: allConditionData.startWith,
  endWith: allConditionData.endWith,
  include: allConditionData.include,
  notIncludes: allConditionData.notIncludes,
  regexp: allConditionData.regexp,
};

export const numberConditionData = {
  inRange: allConditionData.inRange,
  equals: allConditionData.equals,
  notEquals: allConditionData.notEquals,
  lessThan: allConditionData.lessThan,
  lessThanOrEqual: allConditionData.lessThanOrEqual,
  greaterThan: allConditionData.greaterThan,
  greaterThanOrEqual: allConditionData.greaterThanOrEqual,
};

export const dateConditionData = {
  equals: allConditionData.equals,
  notEquals: allConditionData.notEquals,
  before: allConditionData.before,
  onOrBefore: allConditionData.onOrBefore,
  after: allConditionData.after,
  onOrAfter: allConditionData.onOrAfter,
};
export const defaultDataTypeAllData = {
  [defaultDataType.ALL]: {
    key: defaultDataType.ALL,
    name: 'All',
    // icon: '#123',
    icon: MdAbc,
    color: 'gray',
  },
  [defaultDataType.NUM]: {
    key: defaultDataType.NUM,
    name: 'Numerical',
    icon: Md123,
    color: 'green',
    fontSize: '1.5rem',
  },
  [defaultDataType.BOOLEAN]: {
    key: defaultDataType.BOOLEAN,
    name: 'Boolean',
    icon: 'true',
    color: '#07ae09',
    fontSize: '1.5rem',
  },
  [defaultDataType.CAT]: {
    key: defaultDataType.CAT,
    name: 'Categorical',
    // icon: 'Abc',
    icon: MdAbc,
    color: '#00629a',
    fontSize: '1.5rem',
  },
  [defaultDataType.DATETIME]: {
    key: defaultDataType.DATETIME,
    name: 'Date Time',
    // icon: 'DATE',
    icon: MdDateRange,
    color: 'orange',
  },
  [defaultDataType.GEO]: {
    key: defaultDataType.GEO,
    name: 'Geographical',
    icon: 'GEO',
    color: 'black',
  },
  [defaultDataType.ID]: {
    key: defaultDataType.ID,
    name: 'Identifier',
    icon: 'ID',
    fontSize: '1rem',
    // icon: MdAbc,
    color: 'gray',
  },
  [defaultDataType.ID_TEXT]: {
    key: defaultDataType.ID_TEXT,
    name: 'Text Identifier',
    icon: 'ID',
    fontSize: '1rem',
    color: 'gray',
  },
  [defaultDataType.ID_NUM]: {
    key: defaultDataType.ID_NUM,
    name: 'Num Identifier',
    icon: 'ID',
    fontSize: '1rem',
    color: 'gray',
  },
};
export const defaultDataTypeStyles = {
  [defaultDataType.ALL]: defaultDataTypeAllData.ALL,
  [defaultDataType.NUM]: defaultDataTypeAllData.NUM,
  [defaultDataType.CAT]: defaultDataTypeAllData.CAT,
  [defaultDataType.DATETIME]: defaultDataTypeAllData.DATETIME,
  [defaultDataType.GEO]: defaultDataTypeAllData.GEO,
  // [defaultDataType.BOOLEAN]: defaultDataTypeAllData.BOOLEAN,
  // [defaultDataType.ID]: defaultDataTypeAllData.ID,
  [defaultDataType.ID_TEXT]: defaultDataTypeAllData.ID_TEXT,
  [defaultDataType.ID_NUM]: defaultDataTypeAllData.ID_NUM,
};

export const defaultDateKey = {
  CUSTOM: 'CUSTOM',
  LAST7DAYS: 'LAST7DAYS',
  LASTXDAYS: 'LASTXDAYS',
  defalutLastDay: 30,
  mainKey: 'period',
};
export const defaultFilterByType = [
  defaultDataType.ALL,
  defaultDataType.CAT,
  defaultDataType.NUM,
  defaultDataType.DATETIME,
  defaultDataType.GEO,
  defaultDataType.ID,
];
export const defaultDateObject = {
  [`TODAY`]: 'Today',
  [`YESTERDAY`]: 'Yesterday',
  [`THISWEEK`]: 'This week',
  [`LAST7DAYS`]: 'Last 7 days',
  [`THISMONTH`]: 'This month',
  [`LAST30DAYS`]: 'Last 30 days',
  [`THISQUARTER`]: 'This quarter',
  [`THISYEAR`]: 'This year',
  [`CUSTOM`]: 'Custom Date',
  [`LASTXDAYS`]: 'Last X day',
};
export const defaultDateArray = [
  {
    name: 'Today',
    [defaultDateKey.mainKey]: 'TODAY',
  },
  {
    name: 'Yesterday',
    [defaultDateKey.mainKey]: 'YESTERDAY',
  },
  {
    name: 'This week',
    [defaultDateKey.mainKey]: 'THISWEEK',
  },
  {
    name: 'Last 7 days',
    [defaultDateKey.mainKey]: 'LAST7DAYS',
  },
  {
    name: 'This month',
    [defaultDateKey.mainKey]: 'THISMONTH',
  },
  {
    name: 'Last 30 days',
    [defaultDateKey.mainKey]: 'LAST30Days',
  },
  {
    name: 'This quarter',
    [defaultDateKey.mainKey]: 'THISQUARTER',
  },
  {
    name: 'Last X day',
    [defaultDateKey.mainKey]: defaultDateKey.LASTXDAYS,
  },
  {
    name: 'This year',
    [defaultDateKey.mainKey]: 'THISYEAR',
  },
  {
    name: 'Custom Date',
    [defaultDateKey.mainKey]: defaultDateKey.CUSTOM,
  },
];
export const primitiveValues = [
  {
    name: 'null',
    key: null,
  },
  {
    name: 'false',
    key: false,
  },
  {
    name: 'true',
    key: true,
  },
];
